// removed by extract-text-webpack-plugin
module.exports = {"listBottomBlock":"_2bSKaIWJKqHnOxFpw2q0jO","buttonLine":"_3-nUCROAX4rG6d8GVZ-k06","listDescription":"_2XWi8jfwasiA3dQ4EHUCS4","title":"_1lmjevfFu8Rn3moxrawOb3","description":"_2e1ugoEVrXo-0dSqibYqRY","citiesDescription":"_2AbLGGw4zxosF48HIZHJnR","citiesContent":"_6ivFyRm-JaJ2zYPofZdha","collapsed":"X4I3EXz5Lo7kv8bTcaw2M","hidden":"_1XaWGs1NqnHgfJZwWZx8ks"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyListBottomBlock/PropertyListBottomBlock.scss
// module id = 1734
// module chunks = 0